// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"a69e2f43","69":"289127cb","497":"c69c69d3","804":"13cd7b0e"}[chunkId] + ".chunk.css";
};